<template>
  <div class="container">
    <div class="bread-crump">
      <a href="javascript:;" class="bread-crumb-item">Home Page</a> ▸
      <a href="javascript:;" class="bread-crumb-item active"
        >You are not authorized to access</a
      >
    </div>
    <div
      class="about-detail-banner"
      :style="{
        'background-image':
          'url(' + require('/src/assets/img/alkim8-3.svg') + ')',
      }"
    >
      <a href="javascript:;">You are not authorized to access</a>
    </div>
  </div>

  <div class="container-fuild page-503-following-area">
    <div class="container">
      <div class="row">
        <div class="col-12 page-503-following-main">
          <h4>You can browse the following pages.</h4>

          <div class="contact-detail-info-c row m-0 p-0">
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">home</i>
              <b>Home Page</b> <a href="/en">Go</a>
            </div>
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">business</i>
              <b>About</b><a href="/en/about">Read</a>
            </div>
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">shopping_cart</i>
              <b>Products</b><a href="/">Review</a>
            </div>
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">phone</i>
              <b>Contact</b><a href="/en/contact">Call</a>
            </div>
          </div>

          <hr />

          <div class="product-list row">
            <div class="col-12 col-sm-6 col-md-3" v-for="product in 4" :key="product">
              <div class="product-item">
                <img :src="require(`/src/assets/img/productImage.png`)" />
                <small> {{ product }}</small>
              </div>
            </div>

            <section class="page-503-following-all-product">
              <a href="javascript:;">All Products</a>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.page-503-following-area {
  margin-top: 50px;
  margin-bottom: 25;
}
.page-503-following-main h4 {
  padding: 0px 0px 50px 0px;
  text-align: center;
  font-size: 22px;
}
hr {
  margin: 50px 0;
  color: inherit;
  background-color: var(--m3--sys--light--outline);
  border: 0;
  opacity: 1;
}
.page-503-following-main {
  padding: 50px 100px;
  background: #ffffff;
}

.product-list .page-503-following-all-product {
  text-align: center;
  margin-top: 62px;
}
.product-list .page-503-following-all-product > a {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: var(--m3--ref--tertiary--tertiary40);
  padding: 8px 12px;
  border: 1px solid var(--m3--ref--tertiary--tertiary40);
  border-radius: 5px;
}
</style>
